export const indiana = {
  "18000": "Indiana",
  "18001": "Adams County",
  "18003": "Allen County",
  "18005": "Bartholomew County",
  "18007": "Benton County",
  "18009": "Blackford County",
  "18011": "Boone County",
  "18013": "Brown County",
  "18015": "Carroll County",
  "18017": "Cass County",
  "18019": "Clark County",
  "18021": "Clay County",
  "18023": "Clinton County",
  "18025": "Crawford County",
  "18027": "Daviess County",
  "18029": "Dearborn County",
  "18031": "Decatur County",
  "18033": "De Kalb County",
  "18035": "Delaware County",
  "18037": "Dubois County",
  "18039": "Elkhart County",
  "18041": "Fayette County",
  "18043": "Floyd County",
  "18045": "Fountain County",
  "18047": "Franklin County",
  "18049": "Fulton County",
  "18051": "Gibson County",
  "18053": "Grant County",
  "18055": "Greene County",
  "18057": "Hamilton County",
  "18059": "Hancock County",
  "18061": "Harrison County",
  "18063": "Hendricks County",
  "18065": "Henry County",
  "18067": "Howard County",
  "18069": "Huntington County",
  "18071": "Jackson County",
  "18073": "Jasper County",
  "18075": "Jay County",
  "18077": "Jefferson County",
  "18079": "Jennings County",
  "18081": "Johnson County",
  "18083": "Knox County",
  "18085": "Kosciusko County",
  "18087": "Lagrange County",
  "18089": "Lake County",
  "18091": "La Porte County",
  "18093": "Lawrence County",
  "18095": "Madison County",
  "18097": "Marion County",
  "18099": "Marshall County",
  "18101": "Martin County",
  "18103": "Miami County",
  "18105": "Monroe County",
  "18107": "Montgomery County",
  "18109": "Morgan County",
  "18111": "Newton County",
  "18113": "Noble County",
  "18115": "Ohio County",
  "18117": "Orange County",
  "18119": "Owen County",
  "18121": "Parke County",
  "18123": "Perry County",
  "18125": "Pike County",
  "18127": "Porter County",
  "18129": "Posey County",
  "18131": "Pulaski County",
  "18133": "Putnam County",
  "18135": "Randolph County",
  "18137": "Ripley County",
  "18139": "Rush County",
  "18141": "St. Joseph County",
  "18143": "Scott County",
  "18145": "Shelby County",
  "18147": "Spencer County",
  "18149": "Starke County",
  "18151": "Steuben County",
  "18153": "Sullivan County",
  "18155": "Switzerland County",
  "18157": "Tippecanoe County",
  "18159": "Tipton County",
  "18161": "Union County",
  "18163": "Vanderburgh County",
  "18165": "Vermillion County",
  "18167": "Vigo County",
  "18169": "Wabash County",
  "18171": "Warren County",
  "18173": "Warrick County",
  "18175": "Washington County",
  "18177": "Wayne County",
  "18179": "Wells County",
  "18181": "White County",
  "18183": "Whitley County",
};
